/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Booking'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';
import { CONF_API_BASEURL } from '../../../config';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> Jobs -------------------------------------------
    jobs: [],

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'CMS' - 'Jobs'
    ***************************************************************************/
    /***************************************************************************
    * get_Jobs()
    *
    * Desc:
    * Note:
    *
    */
    get_Jobs: state => {

        return state.jobs;

    }, // eof get_Jobs()


    /***************************************************************************
    * get_Jobs_Filtered()
    *
    * Desc: Return 'Office' filtered Jobs.
    * Note: Checks 'if Job is active'.
    *
    */
    get_Jobs_Filtered: state => payload => {

        if (payload !== undefined && payload !== null) {
            return state.jobs.filter(x => x.offices.includes(String(payload).toLocaleUpperCase()) === true && x.active === true).sort((a, b) => {
                return a.sort < b.sort ? -1 : 1;
            });
        }

    }, // eof get_Jobs_Filtered()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'CMS' - 'Jobs'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getJobs()
    *
    * Desc: Save jobs to state.
    * Note:
    *
    */
    mut_call_getJobs: (state, payload) => {

        let jobs = [...payload.jobs];


        jobs.forEach(job => {
            job.offices.sort();
        });

        state.jobs = jobs;

    }, // eo function mut_call_getJobs()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'CMS' - 'Jobs'
    ***************************************************************************/
    /***************************************************************************
    * Call: 'actn_call_getJobs'
    *
    * Desc: Get List of 'Jobs'.
    * Note:
    *
    */
    actn_call_getJobs: (context, payload) => {

        Vue.prototype.$vp_m();
        axios.post(CONF_API_BASEURL, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                context.commit('mut_call_getJobs', response.data.data);
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();


                // >>> --------------------------
                if (error.response && error.response.data.errors) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: error.response.data.errors[0].message
                    });
                } else {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: "Service not available"
                    });
                }
            });

    }, // eo funtion actn_call_getJobs()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/career/career.js